// Controla la animación de aparición del chat "una vez por visita".
// Usa sessionStorage: se reproduce en cada visita nueva (pestaña nueva), no en
// cada navegación/recarga dentro de la misma visita.

const INTRO_KEY = 'avanza_chat_intro_seen'

export function shouldPlayIntro () {
  try {
    return sessionStorage.getItem(INTRO_KEY) !== '1'
  } catch (e) {
    return false
  }
}

export function markIntroSeen () {
  try {
    sessionStorage.setItem(INTRO_KEY, '1')
  } catch (e) {
    // ignorar (modo privado)
  }
}

export function prefersReducedMotion () {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  } catch (e) {
    return false
  }
}
